import fpApiUtil from "./fp-api-util";

const BASE = "factoryplan/master/wip/wips";

const getAll = (params) => fpApiUtil.postParams(BASE, params);
const upsert = (changes) => fpApiUtil.postChanges(`${BASE}/save`, changes);
const remove = (changes) => fpApiUtil.postChanges(`${BASE}/delete`, changes);

const fpWipService = { getAll, upsert, remove };
export default fpWipService;
